import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ms from './locales/ms.json';
import zh from './locales/zh.json';

const resources = {
  en: { translation: en },
  ms: { translation: ms },
  zh: { translation: zh },
};

// Detect browser language
const getBrowserLanguage = (): string => {
  const browserLang = navigator.language.split('-')[0];
  if (['en', 'ms', 'zh'].includes(browserLang)) {
    return browserLang;
  }
  return 'en';
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') || getBrowserLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
